// Core imports
import * as React from 'react';

// Components imports
import SubcategoryBrandFilter from 'src/model/subcategoryBrandFilter.model';

// Style and misc imports
import './Brand.scss';
import Checkbox from 'src/components/common/Checkbox';

class Brand extends React.Component<IBrandProps, any> {
  /*
      handleClick
     */
  private handleClick = (event: any) => {
    event.preventDefault();   
    if (this.props.active === true) {
      this.props.action(this.props.brand, 'remove',this.props.selectionType);
    } else {
      this.props.action(this.props.brand, 'add',this.props.selectionType);
    }
  };
 private formatBrandName = (name: string) => {
  return name;
}

  public render() {
    const { brand } = this.props;   
    return (
      <li className="brand-check" onClick={this.handleClick}>
      <Checkbox
        name={this.formatBrandName(brand.name)}
        value={`check${brand.id}`}
        checked={this.props.active}
        onChange={this.handleClick}
      />
    </li>
    );
  }
}
export default Brand;



interface IBrandProps {
  indexKey: number;
  active: boolean;
  action: any;
  brand: SubcategoryBrandFilter;
  brandName: any;
  selectionType: any;
  
}
